import type { FieldError, FieldErrors } from 'react-hook-form';

export const getTextError = (isSubmitted: boolean, isTouched: boolean, error?: FieldError): string | undefined => {
  if ((isTouched || isSubmitted) && error?.message) {
    return error?.message;
  }
  return undefined;
};

// Only handles flat (top-level) field errors — nested field errors are silently dropped.
export const rhfErrorsToStringMap = (errors: FieldErrors): Record<string, string> => {
  const flat: Record<string, string> = {};
  for (const [key, value] of Object.entries(errors)) {
    if (value?.message && typeof value.message === 'string') {
      flat[key] = value.message;
    }
  }
  return flat;
};
